/**
 * @param {HTMElement} el
 */
export default function inActiveClasses(el) {
    return (el.getAttribute("data-inactive-classes") || "")
      .split(" ")
      .map((c) => c.trim())
      .filter(Boolean);
}